// extracted by mini-css-extract-plugin
module.exports = {"close":"_1P9vhWFllk9j","modal":"Lm5hwvCwwU8l","container":"_11mNcGa5n5jE","title":"PDRi12eecHRO","text":"_2TvJTTfME84l"};